<template>
  <modal :state="state" :index="index" @toggle-modal="emitHideModal($event)">
    <div>
      <h3 class="modal-title">{{title}}</h3>
      <slot></slot>
      <slot name="body-text"></slot>
      <div class="cta">
        <button type="button" @click="cancel" class="btn block grey outline">Cancel</button>
        <button type="button" @click="confirm" class="btn block red">Delete</button>
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
  import Vue from "vue";

  export default Vue.extend({
    props: {
      state: Object,
      title: {
        type: String,
        default: 'Are you sure?'
      }
    },
    data: function() {
      return {};
    },
    methods: {
      confirm() {
        this.$emit('confirm');
      },
      cancel(event) {
        this.$emit('cancel')
        this.emitHideModal(event)
      },
    }
  });
</script>